module.exports = __webpack_public_path__ + "img/Group 1198.38f418af.svg";